// src/data/about.js
// Shared by the desktop and mobile About views.
export const BIO = [
  "Software Engineer with 3+ years shipping production apps across Android, iOS and Web — Flutter is my primary expertise. I've worked across healthcare, productivity, fintech/news and enterprise products, owning features end-to-end: real-time systems, offline-first workflows, auth, payments, push notifications, and production releases.",
  "Beyond Flutter and Dart, I work across the stack — Node.js, Python and Go on the backend, PostgreSQL/MySQL/MongoDB/Redis for data, deployed on AWS with Docker, Linux, NGINX and Jenkins CI/CD. Building real products pushed me to think in systems — event-driven architectures, scalability and reliable data sync — not just screens and APIs.",
  "AI is a core part of my workflow now, for implementation, refactoring and validation, while architecture and product decisions stay mine. I like solving practical engineering problems, and I'm looking to keep growing toward backend and distributed-systems engineering.",
];

export const TECH_CATEGORIES = [
  {
    label: 'Mobile & Web',
    items: ['Flutter', 'Dart', 'Android', 'iOS', 'Flutter Web'],
  },
  {
    label: 'Backend',
    items: ['Node.js', 'Go', 'Python', 'REST APIs', 'WebSockets', 'Socket.IO'],
  },
  {
    label: 'Databases & Infrastructure',
    items: ['PostgreSQL', 'MySQL', 'MongoDB', 'Redis', 'AWS', 'Docker', 'Linux', 'NGINX'],
  },
  {
    label: 'Engineering & Delivery',
    items: [
      'Git', 'Jenkins', 'CI/CD', 'SonarQube', 'Play Store', 'App Store',
      'Offline-first architecture', 'Real-time systems', 'API integration',
    ],
  },
  {
    label: 'Architecture & Systems',
    items: ['Clean Architecture', 'CQRS', 'Event Sourcing', 'Event-driven systems', 'Distributed-system fundamentals'],
  },
  {
    label: 'AI-Assisted Development',
    items: [
      'AI-powered development workflows', 'Code generation', 'Refactoring',
      'Validation', 'Automation', 'AI-agent development',
    ],
  },
];
